import React, { useContext, useState } from "react";
// import { useNavigate } from "react-router-dom";
import locationContext from "../../../app/providers/location/locationContext";
import { useTranslation } from "react-i18next";
import SelectedVehicle from "../../../shared/components/SelectedVehicle";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import ServiceFilter from "./ServiceFilter";
import BackButton from "./BackButton";
import CloseIcon from "@mui/icons-material/Close";
import UserLocationV2 from "../../dashboard/components/UserLocationV2";
import EditIcon from '@mui/icons-material/Edit';
import { altChooseButtonStyleTurquoise, altCloseButtonStyleDark } from "../../../shared/styles/buttonStyles";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";

export default function WorkshopListTopBar() {

    const { t } = useTranslation();
    const [dialogOpen, setDialogOpen] = useState(false)
    const { isMobile } = useWindowSize()
    // const navigate = useNavigate();
    
    const { state: locationState } = useContext(locationContext);
    // const { state: carBrandState, clearBrand } = useContext(carBrandContext);


    return (
        <Box className="workshop-list-top-bar" >
            <Box className="workshop-list-top-bar-content">
                <BackButton />
                <Grid container spacing={2}>
                    <Grid
                        size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                height: '56px',
                                backgroundColor: '#fff',
                                fontSize: '0.875rem',
                                fontWeight: 500,
                                padding: '0 14px',
                                borderRadius: '4px',
                                border: '1px solid #e0e0e0',
                            }}
                            onClick={() => setDialogOpen(true)}
                        >
                            <Typography variant="body1" sx={{ fontWeight: 500, color:"#003C59", fontSize: '0.775rem', width:"80%", overflowX: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {`${t("userLocation.locationHeader")}: ${locationState?.locationAddress?.formatted_address || 'Helsinki'}`}
                            </Typography>
                            <IconButton sx={{width:"15%"}}>
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Grid>
                    <Grid
                        size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
                        sx={{ 
                            '& > *': { 
                                height: '56px' 
                            } 
                        }}
                    >
                        {/* <RegisterplateV2 /> */}
                        <ServiceFilter />
                    </Grid>
                </Grid>
                <SelectedVehicle canEdit={true}/>

                <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} >
                    <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <Typography variant='h6' component="span" sx={{ fontWeight: "bold", color:"#003C59" }}>
                            {t("userLocation.selectLocation")}
                        </Typography>
                        <IconButton onClick={() => setDialogOpen(false)} sx={{ padding: 0, marginTop: "-4px" }}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent sx={{minWidth: !isMobile ? "500px" : "280px", maxWidth: "100%"}}>
                        <UserLocationV2 brandsLoading={false} />
                    </DialogContent>
                    <DialogActions
                        sx={{
                            position: "sticky",
                            bottom: 0,
                            backgroundColor: "#003C59",
                            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
                            padding: "16px 24px",
                            gap: 2,
                            zIndex: 1,
                        }}
                    >
                        <Button onClick={() => setDialogOpen(false)} variant='outlined' sx={{ ...altCloseButtonStyleDark, flex: 1 }}>
                            {t("common.cancel")}
                        </Button>
                        <Button onClick={() => setDialogOpen(false)} variant='outlined' sx={{ ...altChooseButtonStyleTurquoise, flex: 1 }}>
                            {t("common.apply")}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Box>
    );
}